import Vue from "vue";
import Router from "vue-router";

import NotFound from "@/components/NotFound.vue";

import Signin from "@/components/auth/Signin.vue";
import ForgotPassword from "@/components/auth/ForgotPassword.vue";
import ResetPassword from "@/components/auth/ResetPassword.vue";
import SetupAccount from "@/components/auth/SetupAccount.vue";
import ParentReport from "@/components/reports/ParentReport.vue";
import ProspectForm from "@/components/form/ProspectForm.vue";

import Billing from "@/components/billing/Billing.vue";

import Team from "@/components/team/Team.vue";
import TeamSessionHistory from "@/components/team/SessionHistory.vue";

import Center from "@/components/center/Center.vue";
import CenterPackage from "@/components/center/CenterPackage.vue";
import CenterSalesPipelineForm from "@/components/center/salesPipeline/Form.vue";
import CenterSalesPipelineFormPreview from "@/components/center/salesPipeline/FormPreview.vue";

import Finance from "@/components/finance/Finance.vue";
import Availabilities from "@/components/availabilities/Availabilities.vue";
import Appointments from "@/components/appointments/Appointments.vue";
import Appointment from "@/components/appointments/Appointment.vue";
import Analytics from "@/components/analytics/Analytics.vue";

import ClientAcquisition from "@/components/salesPipeline/ClientAcquisition.vue";
import EditPipeline from "@/components/salesPipeline/EditPipeline.vue";

import MySessions from "@/components/mySessions/MySessions.vue";

import Repository from "@/components/repository/Repository.vue";
import Curriculum from "@/components/repository/Curriculum.vue";

import Profile from "@/components/profile/Profile.vue";
import Clients from "@/components/clients/Clients.vue";
import Client from "@/components/clients/Client.vue";
import Session from "@/components/sessions/Session.vue";
import SessionEdit from "@/components/sessions/SessionEdit.vue";
import Report from "@/components/reports/Report.vue";

import SuperAdmin from "@/components/superAdmin/SuperAdmin.vue";
import SuperAdminCenter from "@/components/superAdmin/center/Center.vue";
import SuperAdminSubscription from "@/components/superAdmin/center/subscription/Subscription.vue";
import SuperAdminDatabank from "@/components/superAdmin/databank/Databank.vue";
import SuperAdminDatabankCurriculum from "@/components/superAdmin/databank/curricula/Curriculum.vue";
Vue.use(Router);

// prettier-ignore
export default new Router({
  mode: "history",
  routes: [
    // public
    { name: "NotFound", component: NotFound, path: "*" },
    { name: "Signin", component: Signin, path: "/" },
    { name: "ForgotPassword", component: ForgotPassword, path: "/forgot-password" },
    { name: "ResetPassword", component: ResetPassword, path: "/reset-password/:token" },
    { name: "SetupAccount", component: SetupAccount, path: "/setup-account/:token" },
    { name: "ParentReport", component: ParentReport, path: "/report/:slug" },
    { name: "ProspectForm", component: ProspectForm, path: "/prospect-form/:slug" },
    // owner
    { name: "Billing", component: Billing, path: "/billing" },
    // admin
    { name: "Team", component: Team, path: "/team" },
    { name: "TeamSessionHistory", component: TeamSessionHistory, path: "/team/session-history/:user_id" },
    { name: "Center", component: Center, path: "/center" },
    { name: "CenterTab", component: Center, path: "/center/:tab" },
    { name: "CenterPackage", component: CenterPackage, path: "/center/package/:id" },
    { name: "CenterPackageTab", component: CenterPackage, path: "/center/package/:id/:tab" },
    { name: "CenterSalesPipelineForm", component: CenterSalesPipelineForm, path: "/center/client-acquisition/form" },
    { name: "CenterSalesPipelineFormPreview", component: CenterSalesPipelineFormPreview, path: "/center/client-acquisition/form/preview" },
    { name: "Finance", component: Finance, path: "/finance" },
    { name: "Availabilities", component: Availabilities, path: "/availabilities" },
    { name: "AvailabilitiesTab", component: Availabilities, path: "/availabilities/:tab" },
    { name: "Appointments", component: Appointments, path: "/appointments" },
    { name: "AppointmentsTab", component: Appointments, path: "/appointments/:tab" },
    { name: "Appointment", component: Appointment, path: "/appointments/details/:id" },
    { name: "Analytics", component: Analytics, path: "/analytics" },
    { name: "AnalyticsTab", component: Analytics, path: "/analytics/:tab" },
    { name: "ClientAcquisition", component: ClientAcquisition, path: "/client-acquisition" },
    { name: "EditPipeline", component: EditPipeline, path: "/client-acquisition/edit" },
    // admin | staff read only
    { name: "MySessions", component: MySessions, path: "/my-sessions" },
    { name: "RepositoryTags", component: Repository, path: "/repository" },
    { name: "RepositoryTab", component: Repository, path: "/repository/:tab" },
    { name: "Curriculum", component: Curriculum, path: "/repository/curriculum/:id" },
    // admin | staff
    { name: "Profile", component: Profile, path: "/profile" },
    { name: "Clients", component: Clients, path: "/clients" },
    { name: "Client", component: Client, path: "/clients/:id" },
    { name: "ClientTab", component: Client, path: "/clients/:id/:tab" },
    { name: "Session", component: Session, path: "/session/:slug" },
    { name: "SessionEdit", component: SessionEdit, path: "/session/:slug/edit" },
    { name: "Report", component: Report, path: "/clients/:id/report/:slug/edit" },
    // super admin
    { name: "SuperAdmin", component: SuperAdmin, path: "/super-admin" },
    { name: "SuperAdminTab", component: SuperAdmin, path: "/super-admin/:tab" },
    { name: "SuperAdminCenter", component: SuperAdminCenter, path: "/super-admin/center/:id" },
    { name: "SuperAdminCenterTab", component: SuperAdminCenter, path: "/super-admin/center/:id/:tab" },
    { name: "SuperAdminSubscription", component: SuperAdminSubscription, path: "/super-admin/center/:center_id/subscription/:id" },
    { name: "SuperAdminDatabank", component: SuperAdminDatabank, path: "/super-admin/databank/:id" },
    { name: "SuperAdminDatabankTab", component: SuperAdminDatabank, path: "/super-admin/databank/:id/:tab" },
    { name: "SuperAdminDatabankTabCurriculum", component: SuperAdminDatabankCurriculum, path: "/super-admin/databank/:id/curriculum/:curriculum_id" }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js